import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";

import SessionsLocationFilter from "./SessionsLocationFilter";

// One row on desktop. On a phone the count takes the top line and the two real
// actions take the next one, half each. Clearing lives in the sticky bar's picked
// list, where the client can see what they are about to untick.
const actionSx = { textTransform: "none", flex: { xs: "1 1 0", sm: "0 0 auto" }, minWidth: 0 };

// The venue filter and the pick count share the top line the way the two actions
// share the one below it — half each on a phone, natural width from sm up.
const topRowSx = { flex: { xs: "1 1 0", sm: "0 0 auto" }, minWidth: 0 };

function SessionsToolbar({
  countLabel,
  selectedCount,
  minPicks,
  sessionsN,
  lastPick,
  onSelectNext,
  onRepeatWeekly,
  locationOptions,
  venueFilter,
  onVenueFilter
}) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 1, mb: 2 }}>
      {/* Clubs run the same class at several venues, and a client books at one of
          them — narrowing the list first is the difference between ticking five
          dates and reading every card for its venue. Only worth a control when
          the timetable actually spans more than one. */}
      {locationOptions.length > 1 && <SessionsLocationFilter options={locationOptions} value={venueFilter} onChange={onVenueFilter} sx={topRowSx} />}

      <Chip
        label={`${countLabel} selected`}
        color={selectedCount >= minPicks ? "primary" : "default"}
        sx={{ ...topRowSx, fontWeight: 700, order: 0 }}
      />

      {/* Line break on phones only, so the actions below start a row of their own. */}
      <Box sx={{ order: 2, flexBasis: "100%", height: 0, display: { xs: "block", sm: "none" } }} />

      <Button size="small" variant="outlined" startIcon={<PlaylistAddCheckIcon />} onClick={onSelectNext} sx={{ ...actionSx, order: 3 }}>
        Next {sessionsN}
      </Button>
      <Button
        size="small"
        variant="outlined"
        startIcon={<EventRepeatIcon />}
        disabled={!lastPick || selectedCount >= sessionsN}
        onClick={onRepeatWeekly}
        sx={{ ...actionSx, order: 4 }}
      >
        Repeat weekly
      </Button>
    </Box>
  );
}

export default SessionsToolbar;
